import { SkullScanIcon } from './SkullScanIcon';

/**
 * author: Simran
 * id 3FF20BCB-0BFF-4F46-ABE9-954C8F2EB154
 * name skull-scan
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skull-scan.svg
 * tags
 * - Medical / Hospital 
 */
export const XRayIcon = SkullScanIcon;
export default XRayIcon